import { io } from "socket.io-client";
import { prompt } from "./prompt";
import { initChatMessage, initChatRoom, initChatState } from "./chat.inits";

/** @type {import("vuex").Module<import("./chat.inits").ChatState>} */
export const chat = {
    namespaced: true,

    state: initChatState(),

    getters: {
        _room(state) {
            return state.room?._id ?? sessionStorage.getItem("_chatRoom");
        },
        messages(state) {
            return (state.room?.messages || []).map(initChatMessage);
        },
        loading__lastMessage(state, getters) {
            return getters.messages.at(-1)?.isDone === false;
        },
    },

    mutations: {
        updateMessage(state, { message }) {
            const index = state.room.messages.findIndex(({ _id }) => _id == message._id);

            if (index < 0) {
                state.room.messages.push(message);
            } else {
                state.room.messages.splice(index, 1, message);
            }

            state.room = initChatMessage(state.room);
            if (state.loading) state.loading = false;
        },
    },

    actions: {
        async reset({ state }) {
            sessionStorage.removeItem("_chatRoom");
            state.room = initChatRoom();

            if (state.socket) {
                state.socket.close();
                state.socket = null;
            }
            state.loading = false;
        },
        async init({ commit, dispatch, state, rootState }) {
            if (state.socket) {
                dispatch("join");
                return;
            }

            if (state.loading) return;
            else state.loading = true;

            try {
                const { accessToken } = rootState;
                const sessionId = localStorage.getItem("sessionId");

                /** @type {Partial<import("socket.io-client").ManagerOptions & import("socket.io-client").SocketOptions>} */
                let options = {
                    path: "/socket",
                    transports: ["websocket"],
                    auth: { accessToken, sessionId },
                };

                if (!accessToken) delete options.auth.accessToken;
                if (!sessionId) delete options.auth.sessionId;

                state.socket = io("/chat", options);

                // 세션 처리
                state.socket.on("session", ({ id: sessionId }) => {
                    state.socket.auth = { sessionId };
                    localStorage.setItem("sessionId", sessionId);
                });

                // 초기화 시 방 입장
                state.socket.on("inited", () => dispatch("join"));

                state.socket.on("joined", ({ room, ...response }) => {
                    if (!response.success) {
                        alert(response.message);
                        return;
                    }

                    state.room = initChatRoom(room);
                    sessionStorage.setItem("_chatRoom", room._id);
                    if (state.loading) state.loading = false;
                });

                state.socket.on("sendQuery", ({ message }) => commit("updateMessage", { message }));
                state.socket.on("sendReply", ({ message }) => commit("updateMessage", { message }));
            } catch (error) {
                console.error(error);
                alert(error.message);
                state.socket?.close?.();
                state.socket = null;
            }
        },

        async join({ state, getters }, { _room = getters._room } = {}) {
            if (!state.loading) state.loading = true;
            state.socket.emit("join", { _room });
        },

        async sendQuery({ state, getters }, { _room = getters._room, query } = {}) {
            if (!state.loading) state.loading = true;
            state.socket.emit("sendQuery", { _room, query });
        },
    },

    modules: {
        prompt,
    },
};

export default chat;
